<template>
  <div class="search-container">
    <BbInput v-model="filterValue" class="search-input" size="small" :placeholder="t('common.search')">
      <template #prepend-inner>
        <BbIcon size="small" name="search" />
      </template>
    </BbInput>
  </div>
  <div v-for="option in filteredValues" :key="option.value" class="checkbox-item" @click="toggleValue(option.value)">
    <BbCheckbox
      :model-value="values.includes(option.value)"
      class="select-list-item__checkbox filled-checkbox"
      size="small"
    />
    <TextBody tag="span" :text="option.label" :body-type="1" weight="medium" />
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    filtersConfig: {
      type: Array,
      default: () => [],
      required: true,
    },
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Array,
      default: () => [],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:values'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const filterValue = ref('');
    const filteredValues = computed(() =>
      props.fieldConfig.optionList.filter((item) => item.label.toLowerCase().includes(filterValue.value.toLowerCase())),
    );

    const toggleValue = (value) => {
      emit('update:values', value);
    };

    return { toggleValue, filterValue, filteredValues, t };
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;

  .search-input {
    background: $bb-neutral-0;
  }
}

.checkbox-item {
  padding: $bb-spacing-2 $bb-spacing-3;
  cursor: pointer;
  display: flex !important;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  gap: $bb-spacing-2;
}
</style>
